export const EASING_FAST = 'cubic-bezier(0.22, 0.6, 0.38, 1)'
export const EASING_SLOW = 'cubic-bezier(0.56, 0.05, 0.68, 0.19)'
